import React, { memo, useCallback, useMemo } from 'react'
import { AppMenu } from '../../../components/common/AppMenu'
import { matchPath } from 'react-router-dom'
import ROUTES from '../../../assets/routes'
import { OptionChainViewKey } from '../../../assets/constants'
import OptionChainSettingsForm from './optionChainSettingsForm'

export { OptionChainTableView } from './optionChainSettingsForm'

function OptionChainSettingsDialog({
    open,
    setOpen,
    orderOptionChain = false,
    optionChainViewKey: optionChainViewKeyProp,
    settingsButtonRef
}: {
    open: HTMLElement | undefined
    setOpen: React.Dispatch<React.SetStateAction<HTMLElement | undefined>>
    orderOptionChain?: boolean
    optionChainViewKey?: OptionChainViewKey
    settingsButtonRef?: React.RefObject<HTMLButtonElement | null>
}) {
    const optionChainViewKey = useMemo(
        () => optionChainViewKeyProp ?? (matchPath(ROUTES.simulator, window.location.pathname) ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE),
        [optionChainViewKeyProp, window.location.pathname]
    )

    const handleClose = useCallback(() => {
        setOpen(undefined)
    }, [setOpen])

    return (
        <AppMenu
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            open={Boolean(open)}
            anchorEl={open}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
            onClose={handleClose}
            clickAwayIgnoreRefs={settingsButtonRef ? [settingsButtonRef] : undefined}
            transitionDuration={0}
            PaperProps={{
                sx: {
                    maxHeight: '90vh',
                    mt: 0.5,
                    pt: 0,
                    overflowY: 'auto'
                }
            }}
        >
            <OptionChainSettingsForm orderOptionChain={orderOptionChain} optionChainViewKey={optionChainViewKey} />
        </AppMenu>
    )
}

export default memo(OptionChainSettingsDialog)
